<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useBlogStore } from '~/js/stores/blogs'

import { getGlobalTranslation } from '~/js/composables/translations'

import ButtonPrimary from '~/vue/_atoms/buttons/ButtonPrimary.vue'
import ButtonSecondary from '~/vue/_atoms/buttons/ButtonSecondary.vue'

interface Type {
    type: string,
    title: string
}

interface Props {
    types: Array<Type>
}

defineProps<Props>()

const blogsStore = useBlogStore()
const { filters } = storeToRefs(blogsStore)

const onFilter = (value) => {
    blogsStore.setFilter('type', value.type)
}

</script>

<template>
    <fieldset class="flex">
        <label class="sr-only">
            {{ getGlobalTranslation('Zoek op type') }}
        </label>

        <ButtonSecondary
            v-if="filters.type.value"
            type="button"
            :content="'Alle'"
            utilities="mr-2 mb-2"
            @click="onFilter('')"
        />
        <ButtonPrimary
            v-else
            type="span"
            utilities="mr-2 mb-2"
            :content="'Alle'"
        />

        <template
            v-if="types"
            v-for="type in types"
        >
            <ButtonSecondary
                v-if="filters.type.value != type.type"
                type="button"
                :content="type.title"
                utilities="mr-2 mb-2"
                @click="onFilter(type)"
            />

            <ButtonPrimary
                v-if="filters.type.value == type.type"
                type="span"
                utilities="mr-2 mb-2"
                :content="type.title"
            />
        </template>
    </fieldset>
</template>